export const RETTER_RELEVOS_DEFAULT_TABLE_LIMIT = 200;

export const RETTER_RELEVOS_MIN_HOURS_BEFORE_OFFER_START = 2;
